import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import { removeToken } from "../api/token";

export function useLogout() {
  const { setAuth } = useAuth();
  const { resetCart } = useCart();

  const logout = async () => {
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/api/customers/logout`, {
        method: "POST",
        credentials: "include",
      });
    } catch (error) {
      console.log("Logout failed:", error);
    }

    resetCart(); // Now it can reset the cart without modifying providers
    removeToken();
    setAuth({});
  };

  return { logout };
}
